import { type FC } from 'react';
import { Assert } from '@team/assert';
import { clsx } from '@team/clsx';
import { Css } from '@team/css';
import { Base } from '../base';
import css from './style.module.css';

type Props = {
  width?: string | number;
  fontSize?: string | number;
  lineHeight?: string | number;
  borderRadius?: string | number;
} & HasClassName;

export const Layout: FC<Props> = ({
  className,
  width,
  fontSize,
  lineHeight,
  borderRadius,
}) => {
  const toPx = (value: string | number | undefined) =>
    Assert.isNumber(value) ? Css.toPx(value) : value;

  return (
    <div
      className={clsx(className, css.root)}
      style={{
        '--internal--width': toPx(width),
        '--internal--font_size': toPx(fontSize),
        '--internal--line_height': toPx(lineHeight),
        '--internal--border_radius': toPx(borderRadius),
      }}
    >
      <Base className={css.inner} />
    </div>
  );
};
